<div class="container">

        <div *ngIf="cguONline" class="mt-5" [innerHtml]="cguONline.contract.cgus"></div>

        <div *ngIf="cguOffline" class="mt-5" [innerHtml]="cguOffline.cgus"></div>
        
</div>